module.exports = __webpack_public_path__ + "img/uenoyama-hiroki.d5e37190.jpg";